/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeCalendar = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#DADBE0"></rect>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M5.5 4.75V5.08535C4.9174 5.29127 4.5 5.84689 4.5 6.5V10C4.5 10.8284 5.17157 11.5 6 11.5H10C10.8284 11.5 11.5 10.8284 11.5 10V6.5C11.5 5.84689 11.0826 5.29127 10.5 5.08535V4.75C10.5 4.61193 10.3881 4.5 10.25 4.5C10.1119 4.5 10 4.61193 10 4.75V5H6V4.75C6 4.61193 5.88807 4.5 5.75 4.5C5.61193 4.5 5.5 4.61193 5.5 4.75ZM10 5.5H6C5.44772 5.5 5 5.94772 5 6.5L11 6.5C11 5.94772 10.5523 5.5 10 5.5ZM5 10V7H11V10C11 10.5523 10.5523 11 10 11H6C5.44772 11 5 10.5523 5 10ZM6.25 8.5C6.11193 8.5 6 8.38807 6 8.25C6 8.11193 6.11193 8 6.25 8C6.38807 8 6.5 8.11193 6.5 8.25C6.5 8.38807 6.38807 8.5 6.25 8.5ZM5.5 8.25C5.5 7.83579 5.83579 7.5 6.25 7.5C6.66421 7.5 7 7.83579 7 8.25C7 8.66421 6.66421 9 6.25 9C5.83579 9 5.5 8.66421 5.5 8.25Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.625 6.3125V6.89937C6.60546 7.25972 5.875 8.23206 5.875 9.375V15.5C5.875 16.9497 7.05025 18.125 8.5 18.125H15.5C16.9497 18.125 18.125 16.9497 18.125 15.5V9.375C18.125 8.23206 17.3945 7.25972 16.375 6.89937V6.3125C16.375 6.07088 16.1791 5.875 15.9375 5.875C15.6959 5.875 15.5 6.07088 15.5 6.3125V6.75H8.5V6.3125C8.5 6.07088 8.30412 5.875 8.0625 5.875C7.82088 5.875 7.625 6.07088 7.625 6.3125ZM15.5 7.625H8.5C7.5335 7.625 6.75 8.4085 6.75 9.375L17.25 9.375C17.25 8.4085 16.4665 7.625 15.5 7.625ZM6.75 15.5V10.25H17.25V15.5C17.25 16.4665 16.4665 17.25 15.5 17.25H8.5C7.5335 17.25 6.75 16.4665 6.75 15.5ZM8.9375 12.875C8.69588 12.875 8.5 12.6791 8.5 12.4375C8.5 12.1959 8.69588 12 8.9375 12C9.17912 12 9.375 12.1959 9.375 12.4375C9.375 12.6791 9.17912 12.875 8.9375 12.875ZM7.625 12.4375C7.625 11.7126 8.21263 11.125 8.9375 11.125C9.66237 11.125 10.25 11.7126 10.25 12.4375C10.25 13.1624 9.66237 13.75 8.9375 13.75C8.21263 13.75 7.625 13.1624 7.625 12.4375Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.39001 7.82496C3.39001 4.03076 6.46582 0.954956 10.26 0.954956H27.9481C29.7183 0.954956 31.4202 1.63829 32.6989 2.86247L42.4909 12.2368C43.8445 13.5327 44.61 15.3253 44.61 17.1993V42.175C44.61 45.9692 41.5342 49.045 37.74 49.045H10.26C6.46582 49.045 3.39001 45.9692 3.39001 42.175V7.82496Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M44.4742 15.84H35.45C32.2881 15.84 29.725 13.2768 29.725 10.115V1.18872C30.8322 1.48522 31.8572 2.05667 32.6989 2.86246L42.4908 12.2368C43.5121 13.2146 44.1987 14.4751 44.4742 15.84Z"
                            fill="#EBECF0"
                        ></path>
                        <path
                            d="M44.6099 17.5574H35.4499C31.3396 17.5574 28.0074 14.2253 28.0074 10.1149V0.9552C28.5921 0.960253 29.1689 1.03981 29.7249 1.18871V10.1149C29.7249 13.2768 32.2881 15.8399 35.4499 15.8399H44.4742C44.5638 16.2841 44.6099 16.7392 44.6099 17.1993V17.5574Z"
                            fill="#BABBC5"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.5 19.25V20.2561C14.7522 20.8738 13.5 22.5407 13.5 24.5V35C13.5 37.4853 15.5147 39.5 18 39.5H30C32.4853 39.5 34.5 37.4853 34.5 35V24.5C34.5 22.5407 33.2478 20.8738 31.5 20.2561V19.25C31.5 18.8358 31.1642 18.5 30.75 18.5C30.3358 18.5 30 18.8358 30 19.25V20H18V19.25C18 18.8358 17.6642 18.5 17.25 18.5C16.8358 18.5 16.5 18.8358 16.5 19.25ZM30 21.5H18C16.3431 21.5 15 22.8431 15 24.5L33 24.5C33 22.8431 31.6569 21.5 30 21.5ZM15 35V26H33V35C33 36.6569 31.6569 38 30 38H18C16.3431 38 15 36.6569 15 35ZM18.75 30.5C18.3358 30.5 18 30.1642 18 29.75C18 29.3358 18.3358 29 18.75 29C19.1642 29 19.5 29.3358 19.5 29.75C19.5 30.1642 19.1642 30.5 18.75 30.5ZM16.5 29.75C16.5 28.5074 17.5074 27.5 18.75 27.5C19.9926 27.5 21 28.5074 21 29.75C21 30.9926 19.9926 32 18.75 32C17.5074 32 16.5 30.9926 16.5 29.75Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
